import Spinner from '../../ui/spinner/spinner';

import './blinder.scss';
import isMobileAppWebview from '../../utils/is-mobile-app-webview';
import { SPINNER_SIZES } from '../../ui/spinner/spinner.constants';

const Blinder = () => {
    const isMobileWebView = isMobileAppWebview();

    return (
        <div className='lmp-blinder'>
            <Spinner size={isMobileWebView ? SPINNER_SIZES.MOBILE_APP_WEBVIEW : SPINNER_SIZES.DEFAULT} />
        </div>
    );
};

export default Blinder;
